module.exports = "/_next/static/images/apple-touch-icon-120-d0ed9a7cd8dfb98b3c50f20fae6214fe.png";